import { createRouter, createWebHistory } from "vue-router";
import HomePage from "@/views/HomePage.vue";
import TimestampPage from '@/views/TimestampPage.vue'
import TwitchToken from '@/views/TwitchToken.vue'

import BackofficePage from "@/views/BackofficePage.vue";

import { REDIRECTS, decideNavigation } from '@/navigation.mjs'

const routes = [
    {
        path: '/',
        component: HomePage,
        name: 'Home',
    },
    {
        path: '/display',
        component: TimestampPage,
        name: 'Display',
    },
    {
        path: '/controller',
        component: BackofficePage,
        name: 'Controller',
    },
    {
        path: '/twitch/token',
        component: TwitchToken,
    },
    ...REDIRECTS.map(({ from, subpaths }) => ({
        path: subpaths ? `${from}/:rest(.*)*` : from,
        redirect: (to) => decideNavigation(to.fullPath).to,
    })),
]

const router = createRouter({
    history: createWebHistory(process.env.BASE_URL),
    routes,
});

router.beforeEach((to) => {
    const decision = decideNavigation(to.fullPath)
    if (decision.kind === 'redirect') {
        return decision.to
    }
})

export default router
